import { useGetCheckinFormHistoryQuery } from "apis/client";
import TimeLineTabs from "pages/Coach/ClientDetail/components/TimeLineTabs";

const CheckInHistory = () => {
  // Fetch SWOT data
  const { data, isLoading } = useGetCheckinFormHistoryQuery(0, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
  });

  const answers = data?.data;

  return (
    <>
      {isLoading && (
        <div className="bg-[#fff] px-5 py-10 rounded-lg mt-[5rem]">
          <p className="text-4xl text-center text-primary_blue">Loading...</p>
        </div>
      )}

      {answers?.length > 0 && (
        <TimeLineTabs answers={answers} />
      )}
    </>
  );
};

export default CheckInHistory;
